import * as t from "io-ts";
import { ControlV } from "./controls";

export const GlobalSettingsControlsAndTemplateV = t.type({
  controls: t.array(ControlV),
  template: t.string,
  propertyPathsToWhitelistInFlatProps: t.array(t.string)
});

export type GlobalSettingsControlsAndTemplate = t.TypeOf<
  typeof GlobalSettingsControlsAndTemplateV
>;
